import { Card, Image, Text } from "@clipboard-health/ui-components";
import { CardContent, Stack } from "@mui/material";
import { APP_V2_APP_EVENTS, logEvent } from "@src/appV2/lib/analytics";
import { openInBrowser } from "@src/appV2/NativeAdapters/browser.adapter";

import { Button } from "../../../components/Button";
import { type PlacementCandidate } from "../../../PlacementCandidate/types";
import { usePlacementRecruiterScreeningConfig } from "../../hooks/usePlacementRecruiterScreeningConfig";
import { useTalkToRecruiterCopyText } from "../../hooks/useTalkToRecruiterCopyText";

export function RecruiterScreeningUpskillingCallCard({
  placementCandidate,
}: {
  placementCandidate: PlacementCandidate;
}) {
  const { upskillingCalendlyLink } = usePlacementRecruiterScreeningConfig();
  const { banner, id } = useTalkToRecruiterCopyText();

  return (
    <Card
      sx={{
        p: 1.5,
        background: `linear-gradient(135deg, #FBF2E8 20%, #B7DDFF 100%)`,
      }}
    >
      <CardContent component={Stack} spacing={5} sx={{ alignItems: "center" }}>
        <Stack
          spacing={3}
          flexDirection="row"
          sx={{ alignItems: "center", justifyContent: "space-between" }}
        >
          <Stack spacing={6} sx={{ mr: "-44px !important" }}>
            <Text semibold variant="h6">
              {banner.upskilling}
            </Text>
            <Button
              variant="outlined"
              sx={{ border: "none", width: "fit-content" }}
              onClick={async () => {
                // log event
                logEvent(APP_V2_APP_EVENTS.PLACEMENT_CARD_UPSKILLING_CLICKED, {
                  placementCandidate,
                  copyId: id,
                });

                await openInBrowser({ url: upskillingCalendlyLink });
              }}
            >
              {banner.upskillingAction}
            </Button>
          </Stack>

          <Image src="assets/images/3d-clipboard.png" alt="Clipboard" width="40%" />
        </Stack>
      </CardContent>
    </Card>
  );
}
